import React, { type FC, use, useMemo } from "react";
import { AppRoutes } from "@domain/routing/routeConstants";
import { CompanyContext } from "@domain/context/CompanyContext";
import { UserContext } from "@domain/context/UserProvider";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";
import { ProductAccessUtils } from "@domain/models/utils/ProductAccessUtils";
import { ModuleNav, type NavItem } from "./ModuleNav";

export const ModuleCommonImportExportLinks: FC = () => {
    const { pathname = "" } = useLocation();
    const { companyGQL } = use(CompanyContext);
    const user = use(UserContext);
    const canExportDatev = ProductAccessUtils.canExportDatev(companyGQL, user);
    const selectedKeys = useMemo(() => [pathname], [pathname]);
    const items = useMemo<NavItem[]>(
        () => [
            {
                key: AppRoutes.recordImport,
                to: AppRoutes.recordImport,
                label: <FormattedMessage id="app.titles.data_import" />,
            },
            {
                key: AppRoutes.recordImportAccounts,
                to: AppRoutes.recordImportAccounts,
                label: (
                    <>
                        <FormattedMessage id="app.titles.debitor.pl" /> /{" "}
                        <FormattedMessage id="app.titles.creditor.pl" />
                    </>
                ),
            },
            {
                key: AppRoutes.recordExport,
                disabled: !canExportDatev,
                to: AppRoutes.recordExport,
                label: <FormattedMessage id="app.titles.data_export" />,
            },
            {
                key: AppRoutes.datevConvertDocuments,
                disabled: !canExportDatev,
                to: AppRoutes.datevConvertDocuments,
                label: "Belege",
            },
        ],
        [canExportDatev],
    );
    return <ModuleNav selectedKeys={selectedKeys} items={items} />;
};
